import type { RouteRecordRaw } from 'vue-router'
import {
  incidentRouteCandidates,
  toAnyPermission,
} from '@/config/businessRoutePermissions'

const incidentRoutes: RouteRecordRaw[] = [
  {
    path: 'incidents',
    component: () => import('@/views/incident/IncidentLayout.vue'),
    meta: {
      permission: toAnyPermission(incidentRouteCandidates),
      defaultRouteBasePath: '/incidents',
      defaultRouteCandidates: incidentRouteCandidates,
    },
    children: [
      {
        path: '',
        name: 'incidents',
        component: () => import('@/views/incident/IncidentList.vue'),
        meta: { permission: 'incident:record:view' }
      },
      {
        path: 'config',
        name: 'incident-config',
        component: () => import('@/views/incident/IncidentConfig.vue'),
        meta: {
          permission: {
            any: [
              'incident:config:view',
              'incident:reminder_rule:view',
              'incident:reminder_log:view',
            ],
          },
        },
      },
      {
        path: 'resolved',
        name: 'incident-resolved',
        component: () => import('@/views/incident/IncidentResolvedList.vue'),
        meta: { permission: 'incident:record:view' }
      },
      {
        path: 'reminder-rules',
        redirect: '/incidents/config?tab=rules'
      },
      {
        path: 'reminder-logs',
        redirect: '/incidents/config?tab=logs'
      },
      {
        path: ':id',
        name: 'incident-detail',
        component: () => import('@/views/incident/IncidentDetail.vue'),
        meta: { permission: 'incident:record:view' }
      }
    ]
  }
]

export default incidentRoutes
